import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getProcedureRunUIStringForStudyType} from 'studies/TypedStudyUtils';
import {FONT_PROXIMA_14, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';

import AddProcedureRunButton from '../utils/ui/AddProcedureRunButton';

export default function NoProcedureRunOverview({
  studyId,
  studyType,
  message,
}: {
  studyId: string;
  studyType: StudyType;
  message?: string;
}): JSX.Element {
  const noProcedureRunsMessage =
    message ??
    `Get started by adding ${getProcedureRunUIStringForStudyType(studyType, {includeArticle: true})}${BenchlingConfig.STUDIES_ENABLE_PROCEDURE_RUN_DESIGN ? ' plan' : ''} to this study`;
  return (
    <div className={css(styles.noProcedureRunContainer)}>
      <div className={css(styles.noProcedureRunText)}>{noProcedureRunsMessage}</div>
      <AddProcedureRunButton studyId={studyId} studyType={studyType} />
    </div>
  );
}

const styles = StyleSheet.create({
  noProcedureRunContainer: {
    textAlign: 'center',
  },
  noProcedureRunText: {
    ...FONT_PROXIMA_14,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    textAlign: 'center',
    marginBottom: 24,
  },
});
